export const SET_SYNC_START_DATE = 'SET_SYNC_START_DATE';
export const SET_SYNC_START_DATE_VIEW = 'SET_SYNC_START_DATE_VIEW';
